import { Box, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { SVariantDto } from "@/__generated__/sdk";
import CountdownTimer from "@/app/(main)/_components/CountdownTimer";

type OfferBadgeProps = {
  variant: SVariantDto | null;
  active?: boolean;
};

/* ---------- Main component ---------- */
function OfferBadge({ variant, active = false }: OfferBadgeProps) {
  if (!active || !variant) return null;

  const endAt = variant?.offer?.end_at;
  const endDate = endAt ? new Date(endAt) : null;

  return (
    <Box
      sx={{
        position: "absolute",
        borderBottomRightRadius: 12,
        borderTopRightRadius: { xs: 12, md: 0 },
        backgroundColor: "error.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        top: 0,
        color: "white.main",
        userSelect: "none",
        left: 0,
        p: 0.8,
        px: { md: 2, xs: 1 },
      }}
    >
      <Typography variant="subtitle1" data-price-offer-title>
        {variant.offer?.offerType.title}
      </Typography>

      {endDate && <CountdownTimer endDate={endDate} isActive={active} />}
    </Box>
  );
}

// Custom comparison function for memo (Optional but recommended if 'variant' reference changes often)
export default memo(OfferBadge, (prevProps, nextProps) => {
  return prevProps.active === nextProps.active && prevProps.variant?.offer?.end_at === nextProps.variant?.offer?.end_at;
});
